import React, { useState, useEffect } from "react";
import { Alert, Button, Popconfirm, Radio, Spin, notification } from "antd";
import styled from "styled-components";
import API_URL from "../../config";

const axios = require("axios").default;

const PROVIDER_NAMES = { agora: "Agora", livekit: "LiveKit" };

const PageWrap = styled.div`
  padding: 24px;
  max-width: 560px;
`;

const Title = styled.h4`
  margin-bottom: 8px;
`;

const Description = styled.p`
  color: #555;
  margin-bottom: 24px;
`;

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

function VideoProvider() {
  const [current, setCurrent] = useState(null);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios
      .get(`${API_URL}meet/provider`)
      .then((res) => {
        setCurrent(res.data.data.provider);
        setSelected(res.data.data.provider);
      })
      .catch(() => {
        notification.error({ message: "Görüşme sistemi okunamadı." });
      })
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const res = await axios.post(`${API_URL}meet/provider`, { provider: selected });
      setCurrent(res.data.data.provider);
      notification.success({
        message: `Görüşme sistemi ${PROVIDER_NAMES[res.data.data.provider]} olarak kaydedildi.`,
      });
    } catch (error) {
      notification.error({ message: "Görüşme sistemi kaydedilemedi." });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <PageWrap>
        <Spin />
      </PageWrap>
    );
  }

  if (!current) {
    return (
      <PageWrap>
        <Alert type="error" message="Görüşme sistemi okunamadı. Sayfayı yenileyip tekrar deneyin." />
      </PageWrap>
    );
  }

  return (
    <PageWrap>
      <Title>Görüşme Sistemi</Title>
      <Description>
        Şu anda kullanılan sistem: <strong>{PROVIDER_NAMES[current]}</strong>
      </Description>

      <Actions>
        <Radio.Group value={selected} onChange={(e) => setSelected(e.target.value)}>
          <Radio.Button value="agora">Agora</Radio.Button>
          <Radio.Button value="livekit">LiveKit</Radio.Button>
        </Radio.Group>

        <Alert
          type="warning"
          showIcon
          message="Bu ayar tüm kullanıcıları anında etkiler. Devam eden bir görüşme varken değiştirirseniz taraflar farklı sistemlere düşebilir."
        />

        <Popconfirm
          title={`Görüşme sistemi ${PROVIDER_NAMES[selected]} olarak değiştirilsin mi?`}
          okText="Evet, değiştir"
          cancelText="Vazgeç"
          onConfirm={save}
          disabled={selected === current}
        >
          <Button type="primary" loading={saving} disabled={selected === current}>
            Kaydet
          </Button>
        </Popconfirm>
      </Actions>
    </PageWrap>
  );
}

export default VideoProvider;
